import React from "react";
import logoImg from "../../../Assets/Img/logo_new_green.png";

const SecurityPolicies = () => {
  return (
    <div>
      <div className="logo-image">
        <img src={logoImg} className="login-image" alt="loading..."></img>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-offset-2 col-md-8">
            <h3 className="section-header section-heading">Privacy Policy</h3>
          </div>
          <div className="col-md-offset-1 col-md-10">
            <h4 className="section-header">1. Purpose</h4>
            <div className="readType">
              myConsole has prepared this Privacy Policy to outline our
              practices regarding the collection, use, disclosure, transfer and
              other processing of individually identifiable information about
              you (“Personal Information”) collected when you use myConsole or
              myConsole’s website. myConsole will process any Personal
              Information fairly and lawfully, in accordance with this Privacy
              Policy and in accordance with the General Data Protection
              Regulation (“GDPR”).
            </div>
            <div className="readType">
              In accordance with GDPR definitions, myConsole, 2 Fountain Court,
              Victoria Square, St. Albans, AL1 3TF is the Data Controller, with
              the CEO therefore ultimately responsible for its implementation.
              myConsole has designated Tony Bicknell, Operations Manager, the
              person responsible for Data Protection matters at myConsole. His
              contact details can be found at the end of this document.
            </div>

            <h4 className="section-header">
              2. Information collection and use
            </h4>
            <div className="readType">
              While using our website, we may ask you to provide us with certain
              personally identifiable information that can be used to contact or
              identify you. Personally identifiable information may include, but
              is not limited to your name and contact details ("Personal
              Information").
            </div>
            <h4 className="section-header">
              A. Personal Information Collection
            </h4>
            <div className="readType">
              Subject to this Policy, myConsole will treat as confidential the
              Personal Information that it collects about you. myConsole may
              collect the following categories of Personal Information:
            </div>

            <div className="readType">
              (1) For users: Your name, contact information, employment
              information.
            </div>
            <div className="readType">
              (2) For clients and stakeholders of myConsole users: Your name,
              contact information, employment information, information relating
              to your or your employees’ relationship with the user.
            </div>

            <h4 className="section-header">
              B. Purposes of Use of Personal Information
            </h4>
            <div className="readType">
              myConsole may use the Personal Information listed above for the
              following purposes:
            </div>
            <div className="readType">
              (1) For users: For the purpose of managing your account on
              myConsole for the duration of your employment with myConsole’s
              client organization.
            </div>
            <div className="readType">
              (2) For clients and stakeholders of myConsole users: For the
              purpose of our users following up on projects, in the bid stage or
              during execution. You will not receive any messaging from
              myConsole directly.{" "}
            </div>

            <h4 className="section-header">
              3. Disclosure and international transfers of personal information
            </h4>
            <div className="readType">
              (1) For subscribers/users: For the purposes of sending you our
              updates your Personal Information will be stored on our CRM
              system, the service we use to maintain our distribution lists.  We
              will only do this if you have given us permission to do so.
            </div>
            <div className="readType">
              (2) For supporters, including clients and partners: We will only
              disclose your information internally. Disclosure externally will
              only be with your prior agreement or your consent via an
              individual user agreement or contract.
            </div>
            <div className="readType">
              The recipients of the Personal Information that myConsole collects
              from you will be located in the United Kingdom or Europe, except
              in exceptional and temporary circumstances such as server
              maintenance. myConsole has taken steps to establish appropriate
              data protection and information security requirements with such
              recipients to confirm that Personal Information is properly
              protected in accordance with this Policy and applicable laws. If
              necessary and in accordance with applicable laws, myConsole may
              disclose Personal Information to our outside professional advisers
              and to other third parties that provide products or services to
              myConsole, such as IT systems providers.
            </div>

            <div className="readType">
              Where the processing of Personal Information is delegated to a
              third-party data processor, such as that listed above, myConsole
              will delegate such processing in writing, will choose a data
              processor that provides sufficient guarantees with respect to
              technical and organisational security measures governing the
              relevant processing and will ensure that the processor acts on our
              behalf and under our instructions. In addition, myConsole will
              impose in writing appropriate data protection and information
              security requirements on such third-party data processors.
            </div>

            <h4 className="section-header">4. Log Data</h4>
            <div className="readType">
              Like many site operators, we collect information that your browser
              sends whenever you visit our website ("Log Data").
            </div>
            <div className="readType">
              This Log Data may include information such as your computer's
              Internet Protocol ("IP") address, browser type, browser version,
              the pages of our website that you visit, the time and date of your
              visit, the time spent on those pages and other statistics. This
              helps us to improve the site by monitoring how you use it.
            </div>
            <div className="readType">
              We may use third-party services such as Lead Forensics to collect,
              monitor and analyze this in order to help us measure traffic and
              usage trends for the website. We collect and use this analytics
              information in aggregate form such that it cannot reasonably be
              manipulated to identify any particular individual user.
            </div>

            <h4 className="section-header">5. Changes to the policy</h4>
            <div className="readType">
              Should myConsole decide to substantially modify the manner in
              which it collects or uses Personal Information, the type of
              Personal Information that it collects or any other aspect of this
              Policy, myConsole will notify you as soon as possible of such
              changes by re-issuing a revised Policy on our website
              (http://www.myconsole.co.uk ) and on the software.
            </div>

            <h4 className="section-header">
              6. Accuracy of and access to your personal information
            </h4>
            <div className="readType">
              You are entitled to request and access the information that
              myConsole holds about you (subject to limited exceptions), as
              stated in General Data Protection Regulation (GDPR). In addition,
              you have the right to have inaccurate Personal Information
              corrected or removed and to object to the processing of your
              Personal Information. If you wish to access such Personal
              Information, you should apply in writing to the Operations Manager
              of myConsole via the details below or at the email address set out
              on our website (http://www.myconsole.co.uk ).
            </div>
            <div className="readType">
              To assist us in maintaining accurate Personal Information, you
              must advise us of any changes to your Personal Information. In the
              event that myConsole becomes aware of any inaccuracy in the
              Personal Information that it has recorded, myConsole will correct
              that inaccuracy at the earliest practical opportunity.
            </div>

            <h4 className="section-header">7. Retention of Data</h4>
            <div className="readType">
              myConsole will maintain Personal Information for only as long as
              it is required to do so by or for as long as necessary for the
              purpose(s) for which it was collected. myConsole will remove all
              identifiable Personal Information when it is no longer needed for
              myConsole to deliver their services and fulfill its reporting
              obligations.  More detail about retention is included in
              individual service user agreements.
            </div>

            <h4 className="section-header">8. Security</h4>
            <div className="readType">
              myConsole maintains appropriate technical and organisational
              security measures including staff training to protect Personal
              Information against accidental or unlawful destruction, or
              accidental loss, alteration, unauthorised disclosure or access, in
              compliance with applicable laws.
            </div>

            <h4 className="section-header">
              9. Links to Other Websites and Services
            </h4>
            <div className="readType">
              myConsole is not responsible for the practices employed by
              websites or services linked to or from its website
              (http://http://www.myconsole.co.uk ), including the information or
              content contained therein. Please remember that when you use a
              link to go from this site to another website, our Privacy Policy
              does not apply to third-party websites or services. Your browsing
              and interaction on any third-party website or service, including
              those that have a link or advertisement on our website, are
              subject to that third-party’s own rules and policies.
            </div>

            <h4 className="section-header">10. Questions?</h4>
            <div className="readType">
              Please address all questions to Tony Bicknell, Operations Manager
              of myConsole at tbicknell@myConsole.co.uk or via the contact email
              address set out on our website (http://www.myConsole.co.uk).
            </div>

            <h4 className="section-header">Glossary of Terms</h4>

            <h4 className="section-header">Consent</h4>
            <div className="readType">
              GDPR defines this as any freely given specific and informed
              indication of wishes by which the data subject signifies their
              agreement to personal data relating to themselves being processed.
              Consent can be withdrawn after it has been given.
            </div>
            <div className="readType">
              Where data is “sensitive”, express consent is always sought from
              the data subject before the data can be given to a third-party.
            </div>

            <h4 className="section-header">Data</h4>
            <div className="readType">
              Any information which will be processed, or, used on or by a
              computerised system, additionally it also includes information
              contained within a “relevant filing system” of information. Data
              can therefore be written, tape, photographic or digital.
            </div>

            <h4 className="section-header">Personal Data</h4>
            <div className="readType">
              Personal data means any information relating to a living
              individual who can be identified:
            </div>
            <div className="readType">
              Examples of data which would fall into this category include:
            </div>
            <ul className="readType">
              <li>Names</li>
              <li>Gender</li>
              <li>Date of birth</li>
              <li>Office details</li>
              <li>Emails, phone number and personal address</li>
              <li>IP address from where registration forms are sent</li>
              <li>Postcode </li>
              <li>Schools attended</li>
              <li>A level qualifications</li>
              <li>Career interests</li>
              <li>Interview question answers</li>
              <li>Applications and application status outcomes</li>
            </ul>

            <h4 className="section-header">
              Sensitive Data (termed Special Category under GDPR)
            </h4>
            <div className="readType">
              This means data which relates to sensitive aspects of a living and
              identifiable individual’s life
            </div>
            <div className="readType">
              Examples of data which would fall into this category include:
            </div>
            <ul className="readType">
              <li>Family income</li>
              <li>Number of active guardians</li>
              <li>Parents’ occupation, employment etc.</li>
              <li>Student Finance arrangements</li>
              <li>Information relating to siblings</li>
              <li>Mitigating circumstances</li>
              <li>Photos of an individual</li>
              <li>Photos of student finance documents</li>
              <li>Disability information</li>
              <li>
                Equal opportunity information e.g. ethnicity, sexual
                orientation, religion, marital status etc.
              </li>
              <li>Free School Meal eligibility</li>
              <li>Whether or not a person is a care giver</li>
              <li>POLAR 3 / POLAR 4 data</li>
              <li>ACORN deprivation data</li>
            </ul>

            <h4 className="section-header">Data Subject </h4>
            <div className="readType">
              The person who is the subject of the “personal data”.
            </div>

            <h4 className="section-header">Data Controller</h4>
            <div className="readType">
              A person who determines the purposes for which, and the manner in
              which, any personal data are, or are to be, processed.
            </div>

            <h4 className="section-header">Data Processor</h4>
            <div className="readType">
              Any person (other than an employee of the data controller) who
              processes data on behalf of the data controller. The data
              controller retains responsibility for the actions of the data
              processor.
            </div>

            <h4 className="section-header">Limited Exceptions</h4>
            <div className="readType">
              Processing of personal and sensitive data including responding to
              a Subject Access Request may, in rare circumstances, be restricted
              when personal data is subject to situations involving “crime and
              taxation purposes” which include:
            </div>
            <ul className="readType">
              <li>the prevention or detection of crime;</li>
              <li>the capture or prosecution of offenders; and</li>
              <li>the assessment or collection of tax or duty.</li>
            </ul>

            <h4 className="section-header">Processing</h4>
            <div className="readType">
              Covers almost anything which is done with or to the data,
              including:
            </div>
            <ul className="readType">
              <li>obtaining data</li>
              <li>recording or entering data onto the files</li>
              <li>
                holding data, or keeping it on file without doing anything to it
                or with it
              </li>
              <li>organising, altering or adapting data in any way</li>
              <li>retrieving, consulting or otherwise using the data</li>
              <li>
                disclosing data either by giving it out, by sending it on email,
                or simply by making it available
              </li>
              <li>combining data with other information</li>
              <li>erasing or destroying data</li>
              <li>using the data within research</li>
            </ul>

            <h4 className="section-header">Recipient </h4>
            <div className="readType">
              Any person to whom the data are disclosed, including any person to
              whom they are disclosed in the course of processing the data for
              the Data Controller (e.g. an employee of the data controller, a
              data processor or employee of the data processor).
            </div>
            <h4 className="section-header">Subject Access Request</h4>
            <div className="readType">
              The process by which individuals can find out what personal or
              sensitive data an organisation holds about them, why they hold it
              and who they disclose it to.
            </div>
            <h4 className="section-header">Third Party</h4>
            <div className="readType">
              A natural or legal person, public authority, agency or body other
              than the data subject, controller, processor and persons who,
              under the direct authority of the controller or processor are
              authorised to process personal data.
            </div>
            <div className="row">&nbsp;</div>
            <table className="table readType">
              <tr>
                <td>A-02</td>
                <td>myConsole Privacy Notice</td>
              </tr>
              <tr>
                <td>Prepared by:</td>
                <td>Tony Bicknell</td>
              </tr>
              <tr>
                <td>Effective from:</td>
                <td>25/05/2018</td>
              </tr>
              <tr>
                <td>Review on or before:</td>
                <td>25/05/2019</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div className="row">&nbsp;</div>
      <div className="row">&nbsp;</div>
    </div>
  );
};

export default SecurityPolicies;
